import { RegisteredComponent } from "@builder.io/sdk-react";

export const tableRowBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Table Row",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/rich-text-editor-icon-1/add-row.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  childRequirements: {
    component: "Table Cell",
    message: "Table Row can only have Table Cell components as children!",
  },
  requiresParent: {
    message: "This component must be nested within the Table component!",
    query: {
      "component.name": {
        $in: ["Table", "Comparison Chart"],
      },
    },
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Cell",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Cell",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Cell",
      },
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
